import { Box, Heading, Text } from '@chakra-ui/react'

export const Integrations = () => {
  return (
    <Box p={4}>
      <Heading mb={4}>Integrations</Heading>
      <Text>Integrations page coming soon...</Text>
    </Box>
  )
} 